import { Flex, Skeleton, Spinner, useBreakpointValue } from "@chakra-ui/react";
import { FreeSearchDesktop } from "./FreeSearch";
import { SizeSearchDesktop } from "./SizeSearch";
import { VehicleSearchDesktop } from "./VehicleSearch";
import { loadingIndicatorCSS } from "react-select/dist/declarations/src/components/indicators";
import { useState } from "react";

type SearchProps = {
  loading?: boolean;
};

export function SearchBar({ loading }: SearchProps) {
  const isWide = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: false
  });

  const [loadingSearch, setLoadingSearch] = useState<boolean>(false);

  function loadingToogle() {
    setLoadingSearch(true);
  }

  return (
    <Flex
      display={["none", "Flex"]}
      w={"full"}
      h={"auto"}
      minH={"235px"}
      justifyContent={"center"}
      alignItems={"center"}
      bgColor={"ll-white.main"}
      borderBottom={"2px solid #E3E3E3"}
      mt={"-5px"}
      mb={"25px"}
    >
      {loadingSearch && (
        <Flex
          w={"full"}
          h={"220px"}
          position={"absolute"}
          zIndex={2}
          bgColor={"#ffffff8c"}
          justifyContent={"center"}
          alignItems={"center"}
          cursor={"wait"}
        >
          <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />
        </Flex>
      )}

      <Flex
        zIndex={1}
        w={"865px"}
        flexDir={"column"}
        padding={"25px"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Flex w="full" justifyContent={"flex-end"}>
          {loading ? (
            <>
              <Skeleton mr={"5px"} w={"50%"} height={"65px"} borderRadius={"30px"} />
              <Skeleton ml={"5px"} w={"50%"} height={"65px"} borderRadius={"30px"} />
            </>
          ) : (
            <>
              <FreeSearchDesktop loadingAnim={loadingToogle} />
              <SizeSearchDesktop loadingAnim={loadingToogle} />
            </>
          )}
        </Flex>

        <Flex w={"full"} borderTop={"1px dashed #e9e9e9"} mt={"20px"} />
        <VehicleSearchDesktop loading={loading} loadingAnim={loadingToogle} />
      </Flex>
    </Flex>
  );
}
